export default defineNuxtRouteMiddleware((from, to) => {
  if (import.meta.server) {
    return
  }
  const cartStore = useCartStore()
  const { refetchCart } = cartStore

  if (from.name !== to.name) {
    refetchCart()
  }
})
